import { inject, Injectable, OnDestroy } from '@angular/core';
import { BROADCAST_MESSAGES, IActiveParsing } from '../../interfaces/cv-parse';
import { BroadcastBaseService } from '../../classes/broadcast-base';
import { CvParseFacadeService } from '../facades/cv-parse.facade.service';
import { Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CvParseBroadcastChannelService extends BroadcastBaseService<BROADCAST_MESSAGES> implements OnDestroy {
  private cvParseFacadeService = inject(CvParseFacadeService);

  constructor() {
    super('cv-parse-channel');
  }

  activeParsing: IActiveParsing;
  private subscriptions$ = new Subscription();

  init() {
    this.subscriptions$.add(
      this.cvParseFacadeService.activeParsingStatus$.subscribe((parsing) => {
        this.activeParsing = parsing;
      })
    );
  }

  protected onMessage(message: BROADCAST_MESSAGES): void {
    // Handle incoming messages as needed
    console.debug('[CvParseBroadcastChannel] Received message on cv-parse-channel:', message);
    if (message === BROADCAST_MESSAGES.CHECK_ACTIVE_PARSING && !this.activeParsing?.loading) {
      this.cvParseFacadeService.checkActiveParsing();
    }
  }

  ngOnDestroy(): void {
    this.closeChannel();
    this.subscriptions$.unsubscribe();
  }
}
